import React, { useContext, useRef, useState } from 'react';
import { Form, Button } from "react-bootstrap";
import * as XLSX from 'xlsx'
import Auth from "../../../Utilities/Auth";
import { useDispatch } from "react-redux";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import { AgentContext } from "../AgentComponent";
import { importAgentAction } from "../../../Redux/Action/AgentAction";
import CommonToast from '../../../Utilities/CommonToast';

function AgentImport(props) {
    // hooks
    const dispatch = useDispatch()
    const submitRef = useRef()
    // states
    const [excelFile, setExcelFile] = useState(null);
    const [excelFileError, setExcelFileError] = useState(null);

    // getting data from context
    const { setAllAgentReload, setImportModalShow } = useContext(AgentContext)


    // it will contain array of objects

    // handle File
    const fileType = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const handleFile = (e) => {
        let selectedFile = e.target.files[0];
        if (selectedFile) {
            // console.log(selectedFile.type);
            if (selectedFile && fileType.includes(selectedFile.type)) {
                let reader = new FileReader();
                reader.readAsArrayBuffer(selectedFile);
                reader.onload = (e) => {
                    setExcelFileError(null);
                    setExcelFile(e.target.result);
                }
            } else {
                setExcelFileError('Please select only excel file types');
                setExcelFile(null);
            }
        } else {
            console.log('plz select your file');
        }
    }

    // submit function
    const handleSubmit = (e) => {
        e.preventDefault();
        let userDetail = JSON.parse(Auth.header().userdetail || "{}")
        if (excelFile !== null) {
            const workbook = XLSX.read(excelFile, { type: 'buffer' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);

            // set created by
            // const newData = data.filter(singleData => {
            //     singleData.created_by = userDetail.id
            //     return {
            //         full_name: item["Full Name"] || "",
            //         mobile: item.Mobile || "",
            //         whats_app: item.WhatsApp || "",
            //         adhaar_no: item["Adhaar No"] || "",
            //         collection_area_state: item.State || "",
            //         collection_area_district: item.District || "",
            //         collection_area_police_station: item["Police Station"] || "",
            //         collection_area_post_office: item["Post Office"] || "",
            //         collection_area_village: item.Village || "",
            //         collection_area_para: item.Para || "",
            //         collection_area_pincode: item.Pincode || "",
            //         collection_area_place: item.Place || "",
            //         collection_area_city: item.City || "",
            //         agent_address: item.agent_address || "",
            //         user_name: item.Username || "",
            //         password: "123456",
            //         created_by: userDetail.id
            //     }
            // })

            let has_error = false
            const newData = []
            data.map((item, index) => {
                if ((!item["Name"] || item["Name"].length < 2) && !has_error) {
                    CommonToast.warning(`Name must be more than 2 characters at row ${index + 2}`);
                    has_error = true;
                } else if ((!item.Mobile || item.Mobile.length < 10) && !has_error) {
                    // console.log(item)
                    CommonToast.warning(`Mobile must be at least 10 digit at row ${index + 2}`);
                    has_error = true;
                }
                // else if ((!item["Adhaar No"] || item["Adhaar No"].length < 5) && !has_error) {
                //     CommonToast.warning(`Adhaar no must be more than 4 digits at row ${index + 2}`);
                //     has_error = true;
                // }
                // else if ((!item.Username || item.Username.length < 1) && !has_error) {
                //     CommonToast.warning(`Username must be at least 1 character at row ${index + 2}`);
                //     has_error = true;
                // }
                else if (!has_error) {
                    // making password
                    const name = item["Name"] || ""
                    const mobile = (item["Mobile"] || "") + ""
                    const prefix = name.replace(/\s+/g, "").substring(0, 2).toLowerCase();
                    const post_fix = mobile.slice(-4);
                    // const post_fix = "12345";
                    // console.log(adhaar_no)

                    // formatted new data
                    const formatted_new_data = {
                        full_name: item["Name"] || "",
                        mobile: item.Mobile || "",
                        whats_app: item.WhatsApp || "",
                        collection_area_para: item["Neighborhood"],
                        // adhaar_no: item["Adhaar No"] || "",
                        collection_area_state: item.State || "",
                        collection_area_district: item.District || "",
                        collection_area_police_station: item["Police Station"] || "",
                        // collection_area_post_office: item["Post Office"] || "",
                        collection_area_village: item.Village || "",
                        // collection_area_para: item.Para || "",
                        // collection_area_pincode: item.Pincode || "",
                        collection_area_place: item.Place || "",
                        collection_area_city: item.City || "",
                        // agent_address: item.agent_address || "",
                        user_name: item.Mobile,
                        password: prefix + post_fix,
                        created_by: userDetail.id,
                    }

                    if (item.ID) {
                        formatted_new_data.id = item.ID
                    }

                    newData.push(formatted_new_data)
                }
            })

            // console.log(newData)

            // making payload for import agents
            const payload = {
                data: { agentDatailArr: newData },
                submitRef,
                setAllAgentReload,
                setImportModalShow
            }

            // console.log(newData)
            // action dispatch
            !has_error && dispatch(importAgentAction(payload))

        } else {

        }
    }
    return (
        <>
            <Form onSubmit={e => handleSubmit(e)}>
                {/*vendor name field*/}
                <Form.Group className="mb-2" controlId="formBasicEmail">
                    <Form.Label>Upload agents</Form.Label>
                    <Form.Control type="file" required={true} onChange={e => handleFile(e)} />
                    {excelFileError && <div className='text-danger'
                        style={{ marginTop: 5 + 'px' }}>{excelFileError}</div>}
                </Form.Group>

                <Button ref={submitRef} variant="success" disabled={false} className="mt-2 btn-sm" type="submit">
                    import
                    <ButtonLoader />
                </Button>
                <br />
            </Form>
        </>
    );
}

export default AgentImport;